module.exports = __webpack_public_path__ + "static/media/unauth_image.f0708276.jpg";